import { myApi } from '../../config/axiosConfig';

export const getCoreSysUsers = async () => {

    const response = await myApi.get('/idle/config/coresys/users');

    return response.data;

}

export const getIdleConfig = async () => {

    const response = await myApi.get('/idle/config');

    return response.data;

}